import { render } from "./ShortlistingManagement.vue?vue&type=template&id=cb821cac"
import script from "./ShortlistingManagement.vue?vue&type=script&lang=js"
export * from "./ShortlistingManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__